import { Component, type ErrorInfo, type ReactNode } from "react";

interface ErrorBoundaryProps {
	children: ReactNode;
}

interface ErrorBoundaryState {
	hasError: boolean;
}

export class ErrorBoundary extends Component<
	ErrorBoundaryProps,
	ErrorBoundaryState
> {
	override state: ErrorBoundaryState = { hasError: false };

	static getDerivedStateFromError(): ErrorBoundaryState {
		return { hasError: true };
	}

	override componentDidCatch(error: Error, info: ErrorInfo) {
		console.error("Unhandled rendering error", error, info.componentStack);
	}

	override render() {
		if (!this.state.hasError) {
			return this.props.children;
		}

		return (
			<div className="app-error" role="alert">
				<h1 className="app-error__title">Algo deu errado</h1>
				<p className="app-error__description">
					Não conseguimos carregar esta tela. Recarregue a página para tentar
					novamente.
				</p>
				<button
					type="button"
					className="app-error__action"
					onClick={() => window.location.reload()}
				>
					Recarregar
				</button>
			</div>
		);
	}
}
